import { render, staticRenderFns } from "./TypedText.vue?vue&type=template&id=39627c08"
import script from "./TypedText.vue?vue&type=script&lang=js"
export * from "./TypedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports